import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72737482")

_pushScopeId("data-v-72737482")
const _hoisted_1 = { class: "text-gray-333 basic-flow-setting-container" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "basic-flow-table mb-8" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-collapse-down text-2xl" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('basicFlowNote')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        headers: _ctx.basicFlowHeaders,
        data: _ctx.applicationBasicFlowSettingsList
      }, {
        application_define_name: _withId(({ item }) => [
          _createVNode("div", _hoisted_4, _toDisplayString(item.application_define_name), 1)
        ]),
        total_level: _withId(({ item }) => [
          _createVNode("div", _hoisted_5, _toDisplayString(item.total_level), 1)
        ]),
        edit: _withId(({ item }) => [
          _withDirectives(_createVNode("div", {
            class: "text-center",
            onClick: ($event: any) => (_ctx.editBasicFlowSettings(item))
          }, [
            _createVNode(_component_BaseIcon, {
              name: "pencil-line",
              class: "cursor-pointer"
            })
          ], 8, ["onClick"]), [
            [_directive_tooltip, _ctx.t('actionEdit')]
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Button, { class: "mr-4" }, {
        default: _withId(() => [
          _createVNode(_component_BaseIcon, {
            name: "import",
            class: "mr-1"
          }),
          _createTextVNode(_toDisplayString(_ctx.t('import')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, { class: "mr-4" }, {
        default: _withId(() => [
          _createVNode(_component_BaseIcon, {
            name: "export",
            class: "mr-1"
          }),
          _createTextVNode(_toDisplayString(_ctx.t('export')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, { variant: "outline-primary" }, {
        default: _withId(() => [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.t('formatDownload')), 1)
        ]),
        _: 1
      })
    ])
  ]))
})